import { SxProp, View } from 'dripsy';
import React from 'react';
import { useHasFeature } from './useHasFeature.hook';

export interface HasFeatureContextProps {
  children?: React.ReactElement;
  feature: string;
  variation: string;
  sx?: SxProp;
}

export const UtxHasFeature = (props: HasFeatureContextProps) => {
  const featureStatus = useHasFeature({ feature: props.feature, variation: props.variation });

  return featureStatus.enabled ? <View sx={{ flex: 1, ...props.sx }}>{props.children}</View> : null;
};
